import _ from 'lodash';

export const NAME = 'environicsDashboard';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;

        case 'ENVIRONICS_DASHBOARD__FETCH_SEGMENTS_DATA__END': {
            return {
                ...state,
                audienceSegments: action.payload.data,
            };
        }
    }
}
